import { render, staticRenderFns } from "./create-bill[project].vue?vue&type=template&id=0b4bba4e&"
import script from "./create-bill[project].vue?vue&type=script&lang=js&"
export * from "./create-bill[project].vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports